import { render, staticRenderFns } from "./dicomAnonymizeDownload.vue?vue&type=template&id=30354918&scoped=true"
import script from "./dicomAnonymizeDownload.vue?vue&type=script&lang=js"
export * from "./dicomAnonymizeDownload.vue?vue&type=script&lang=js"
import style0 from "./dicomAnonymizeDownload.vue?vue&type=style&index=0&id=30354918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30354918",
  null
  
)

export default component.exports